import moment from "moment";
import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";

import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import { imageApi } from "../../../../initialpage/hooks/HrApi";

const toBn = (n) => n.replace(/\d/g, (d) => "০১২৩৪৫৬৭৮৯"[d]);
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const RequestProductRepView = () => {
  const { req_id } = useParams();
  console.log(req_id);
  const navigate = useNavigate();
  // get doneReqSlip Data
  const {
    data: doneReqSlip,
    error,
    mutate,
  } = useSWR(
    req_id ? `store/requisition/product/request/admin/slip/${req_id}` : null,
    fetcher
  );
  console.log(doneReqSlip);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>Requisition Details - BBA STORE</title>
        <meta name="description" content="Requisition Details - BBA STORE" />
      </Helmet>
      {!doneReqSlip ? (
        <NotFoundPage />
      ) : (
        <div className="page-wrapper">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                className="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i className="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div>
              <button
                onClick={handlePrint}
                type="button"
                className="btn btn-color px-3 printBtn show ms-auto my-3 me-2 "
              >
                <i className="fa fa-print"></i>
                <span> Print</span>
              </button>
            </div>
          </div>

          <section ref={componentRef} className=" mx-3 py-4 ">
            <div className="my-5">
              {doneReqSlip.info[0] && (
                <>
                  <div className="row">
                    <div className="col-3 col-md-4 col-lg-3"></div>
                    <div className="col-6 col-md-6 col-lg-6 "></div>
                    <div className="col-3 col-md-2 col-lg-3">
                      <h4>
                        এন্ট্রি নং: {toBn(`${doneReqSlip.info[0].REQUEST_ID}`)}
                      </h4>
                      <h4>
                        তারিখ:{" "}
                        {toBn(
                          `${moment(
                            new Date(doneReqSlip.info[0].REQUEST_DATE)
                          ).format("DD-MM-YYYY")}`
                        )}
                      </h4>
                    </div>
                  </div>

                  <div className="text-center mt-3">
                    <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                    </h4>
                   
                  </div>

                  <div className=" px-2 mt-5 py-4 d-flex justify-content-between">
                    <div>
                      <h4 className="mb-3">
                        চাহিদাকারী কর্মকর্তা /কর্মচারীর নাম:{" "}
                        {doneReqSlip.info[0].NAME_ENGLISH}
                      </h4>
                      <h4>পদবী: {doneReqSlip.info[0].DESIGNATION}</h4>
                    </div>
                    <div>
                      <h4 className="mb-3">
                        শাখা: {doneReqSlip.info[0].DEPARTEMENT}
                      </h4>
                      <h4>
                        নম্বর: {toBn(`${doneReqSlip.info[0].MOBILE_PHONE}`)}
                      </h4>
                    </div>
                  </div>
                </>
              )}

              <div className="px-2 my-5">
                <table className="table ">
                  <thead>
                    <tr>
                      <th className="fw-bold col-design">ক্রমিক নং</th>
                      <th className="fw-bold col-design">দ্রব্যর নাম</th>

                      <th className="fw-bold col-design">চাহিদার পরিমান</th>
                      <th className="fw-bold col-design">ইউনিট</th>
                      <th className="fw-bold col-design">
                        অনুমোদিত সরবরাহের পরিমাণ
                      </th>
                      <th className="fw-bold col-design ">
                        {" "}
                        আবেদনকারীর মন্তব্য
                      </th>
                      <th className="fw-bold col-design">
                        অনুমোদনকারীর মন্তব্য
                      </th>
                      <th className="fw-bold col-design">
                        স্টোর অফিসার মন্তব্য
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {doneReqSlip.info &&
                      doneReqSlip.info.map((item, index) => (
                        <tr key={index}>
                          <td className="col-design">{toBn(`${++index}`)}</td>
                          <td className="col-design">{item.PRODUCT_NAME}</td>

                          <td className="col-design">
                            {toBn(`${item.REQUEST_QTY}`)}
                          </td>
                          <td className="col-design">{item.UNIT}</td>
                          <td className="col-design">
                            {item.APPROVED_QTY
                              ? toBn(`${item.APPROVED_QTY}`)
                              : ""}
                          </td>
                          <td className="col-design  text-start">
                            {item.REQUEST_REMARKS &&
                              item.REQUEST_REMARKS !== null &&
                              item.REQUEST_REMARKS !== "null"
                              ? item.REQUEST_REMARKS
                              : ""}
                          </td>
                          <td className="col-design text-start">
                            {" "}
                            {item.APPROVED_REMARKS &&
                              item.APPROVED_REMARKS !== null &&
                              item.APPROVED_REMARKS !== "null"
                              ? item.APPROVED_REMARKS
                              : ""}
                          </td>
                          <td className="col-design text-start">
                            {" "}
                            {item.STORE_REMARK &&
                              item.STORE_REMARK !== null &&
                              item.STORE_REMARK !== "null"
                              ? item.STORE_REMARK
                              : ""}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  {/* <tbody>
                    {doneReqSlip && (
                      <tr>
                        <td className="col-design"></td>
                        <td className="col-design"></td>
                        <td className="col-design total-design">
                          মোট চাহিদা :{" "}
                          <span className="fw-bold">
                            {toBn(`${doneReqSlip.totalRequQty}`)} টি{" "}
                          </span>
                        </td>
                        <td className="col-design total-design">
                          মোট অনুমোদিত :{" "}
                          <span className="fw-bold">
                            {toBn(`${doneReqSlip.totalAppQty}`)} টি{" "}
                          </span>
                        </td>
                        <td className="col-design"></td>
                      </tr>
                    )}
                  </tbody> */}
                </table>
              </div>

              <div className=" px-2 py-5 row">
                <div className="col-4 col-md-4 col-lg-4">
                  {doneReqSlip && doneReqSlip.info[0] ? (
                    <div
                      className=" square"
                      style={{
                        backgroundImage: `url("${imageApi}${doneReqSlip?.info[0]?.SIGNATURE_PATH}")`,
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                  <h5 className="text-start">
                    <span style={{ borderBottom: "1px solid #000" }}>
                      আবেদনকারীর স্বাক্ষর
                    </span>
                  </h5>
                </div>
                <div className="col-4 col-md-4 col-lg-4 text-center ">
                  {" "}
                  {doneReqSlip.info[0].REQUEST_STATUS != 0 &&
                    doneReqSlip &&
                    doneReqSlip.signatures[0] ? (
                    <div
                      className=" square"
                      style={{
                        backgroundImage: `url("${imageApi}${doneReqSlip.signatures[0].SIGNATURE_PATH}")`,
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                  <h5>
                    <span style={{ borderBottom: "1px solid #000" }}>
                      অনুমোদনকারীর স্বাক্ষর
                    </span>
                  </h5>
                </div>
                <div className="col-4 col-md-4 col-lg-4 text-end">
                  {doneReqSlip.info[0].REQUEST_STATUS != 0 &&
                    doneReqSlip &&
                    doneReqSlip.signatures[1] ? (
                    <div
                      className=" square"
                      style={{
                        backgroundImage: `url("${imageApi}${doneReqSlip.signatures[1].SIGNATURE_PATH}")`,
                      }}
                    ></div>
                  ) : (
                    ""
                  )}

                  <h5 className="text-end">
                    <span style={{ borderBottom: " 1px solid #000" }}>
                      স্টোর কিপার এর স্বাক্ষর
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default RequestProductRepView;
